import { Box, Typography, useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";

export default function StepContainer({ children, title, action }) {
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box display="flex" flexDirection="column" gridGap={16} mt={6}>
      <Box
        display="flex"
        flexDirection={isSmDown ? "column" : "row"}
        alignItems={isSmDown ? "stretch" : "center"}
        gridGap={isSmDown ? 12 : 24}
      >
        <Typography variant="h1" color="primary">
          {title}
        </Typography>

        {action ? <Box width={isSmDown ? "100%" : "auto"}>{action}</Box> : null}
      </Box>

      {children}
    </Box>
  );
}
